const NewTag = () => (
  <div className="flex bg-hh-accent-light items-center justify-center rounded-[4px] px-2 h-6 py-[2px] m-[3px]">
    <span className="font-inter-medium text-sm text-white">new</span>
  </div>
);

export default NewTag;
